// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateRaffle_container__QgR7l {
  animation: CreateRaffle_init__5qjdc 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 16px;
}

/*---Title---*/
.CreateRaffle_container__QgR7l .CreateRaffle_titleContainer__aMhzt {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.CreateRaffle_container__QgR7l .CreateRaffle_titleContainer__aMhzt h4 {
  width: 95%;
  text-align: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.CreateRaffle_arrow__8043D {
  transition: 0.3s;
}

.CreateRaffle_arrow__8043D:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.CreateRaffle_container__QgR7l .CreateRaffle_typeSelector__srFbR {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.CreateRaffle_container__QgR7l .CreateRaffle_typeSelector__srFbR h3 {
  font-size: 1rem;
  font-weight: 600;
  font-family: Roboto, sans-serif;
}

.CreateRaffle_container__QgR7l .CreateRaffle_form__KoYMh {
  display: flex;
  justify-content: center;
  align-items: center;
}

.CreateRaffle_container__QgR7l .CreateRaffle_form__KoYMh .CreateRaffle_inputItem__Xa0Wv {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.CreateRaffle_container__QgR7l .CreateRaffle_form__KoYMh .CreateRaffle_inputSettlementDate__FRL46 {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 24vh;
}

.CreateRaffle_container__QgR7l .CreateRaffle_form__KoYMh .CreateRaffle_inputItem__Xa0Wv h3 {
  font-size: 1rem;
}

.CreateRaffle_container__QgR7l .CreateRaffle_form__KoYMh .CreateRaffle_inputItem__Xa0Wv .CreateRaffle_titleinput__65em3 {
  width: 80%;
  font-size: 1rem;
  font-weight: 600;
  font-family: Roboto, sans-serif;
}

.CreateRaffle_container__QgR7l .CreateRaffle_form__KoYMh .CreateRaffle_inputItem__Xa0Wv .CreateRaffle_active__pFaGL {
  width: 80%;
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Sorteos/Create/CreateRaffle.module.css"],"names":[],"mappings":"AAAA;EACE,sCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,eAAe;AACjB","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  font-size: 16px;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  width: 95%;\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.arrow {\n  transition: 0.3s;\n}\n\n.arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .typeSelector {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.container .typeSelector h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  font-family: Roboto, sans-serif;\n}\n\n.container .form {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .form .inputItem {\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .form .inputSettlementDate {\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 24vh;\n}\n\n.container .form .inputItem h3 {\n  font-size: 1rem;\n}\n\n.container .form .inputItem .titleinput {\n  width: 80%;\n  font-size: 1rem;\n  font-weight: 600;\n  font-family: Roboto, sans-serif;\n}\n\n.container .form .inputItem .active {\n  width: 80%;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CreateRaffle_container__QgR7l`,
	"init": `CreateRaffle_init__5qjdc`,
	"titleContainer": `CreateRaffle_titleContainer__aMhzt`,
	"arrow": `CreateRaffle_arrow__8043D`,
	"typeSelector": `CreateRaffle_typeSelector__srFbR`,
	"form": `CreateRaffle_form__KoYMh`,
	"inputItem": `CreateRaffle_inputItem__Xa0Wv`,
	"inputSettlementDate": `CreateRaffle_inputSettlementDate__FRL46`,
	"titleinput": `CreateRaffle_titleinput__65em3`,
	"active": `CreateRaffle_active__pFaGL`
};
export default ___CSS_LOADER_EXPORT___;
